// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as JsxRuntime from "react/jsx-runtime";

function $$Text(props) {
  return JsxRuntime.jsx("p", {
              children: props.children,
              className: Belt_Option.getWithDefault(props.className, "")
            });
}

var make = $$Text;

export {
  make ,
}
/* react/jsx-runtime Not a pure module */
